import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubEditRepoCrumb(props: Partial<BreadcrumbData>) {
  return <Breadcrumb {...props} name="Edit" />;
}
